<div #accordionHeader class="accordion" [ngClass]="{'accordion--collapsed': isCollapsed,
                                   'accordion--framed': titleFrame,
                                   'accordion--transparent': transparentBg,
                                   'accordion--small': isSmall,
                                   'accordion--no-padding': noPadding}">
  @if (showHeader) {
    <div class="accordion__header level is-mobile" (click)="toggleCollapse()">
      <div class="level-left" [class.flexbox]="showActiveNr">
        <div class="level-item">
          <div class="accordion__title is-bold is-medium">
            @if (preIndex) {
              <span class="preIndex">{{ preIndex }}.</span>
            }
            @if (translateTitle) {
              <span>
                @if (!titleChildTranslate && !isChildVerification) {
                  {{ title | translate:{ prefix: prefix, postfix: postfix } }}
                }
                @if (titleChildTranslate) {
                  <span>{{ title | translate }}</span>
                  <span class="child_name"> - {{ prefix }} {{ postfix }}</span>
                }
                @if (isChildVerification) {
                  <span>{{ title | translate }} </span>
                  <span class="child_name">{{ childFirstName }} {{ childLastName }}:</span>
                }
              </span>
            }
            @if (!translateTitle) {
              <span>{{ title }}</span>
            }
            @if (postIndex) {
              <span class="postIndex">{{ postIndex }}</span>
            }
          </div>
          @if (subTitle) {
            <div class="accordion__subtitle" [innerHTML]="subTitle | translate: {year: statement?.fullYear || ''}">
            </div>
          }
        </div>
        @if (showActiveNr) {
          <div class="active_nr_box">
            <span>{{ currActiveNr }}</span>
            <span>/</span>
            <span>{{ allActiveNr }}</span>
          </div>
        }
      </div>
      @if (canCollapse) {
        <div class="level-right">
          <!-- <div class="level-item" (click)="onRemoveClicked($event)" *ngIf="showRemove">
          <a [ngClass]="isRemoveActive ? 'accordion__remove' : 'accordion__remove inactive'">
            <div class="svg-icon">
              <img src="../../../assets/svg/delete_simply_gray.svg" alt="delete" class="svg-icon__img" />
              <span class="svg-icon__label">{{ 'COMMON.REMOVE' | translate }}</span>
            </div>
          </a>
        </div> -->
        <div class="level-item">
          @if (currentId) {
            <img src="../../../assets/svg/minus_accordion.svg" class="icon_up" id="close_{{currentId}}">
            <img src="../../../assets/svg/plus_accordion.svg" class="icon_down" id="open_{{currentId}}">
          }
          @if (!currentId) {
            <img src="../../../assets/svg/minus_accordion.svg" class="icon_up">
            <img src="../../../assets/svg/plus_accordion.svg" class="icon_down">
          }
        </div>
      </div>
    }
  </div>
}

<!--Start OCR Alert-->
@if (showScanAlert && !isBusiness && usedOCR) {
  <div class="employer__alert" [hidden]="isCollapsed">
    <div class="employer__alert-desc">
      {{ 'OCR_ALERT.DESCRIPTION' | translate }}
    </div>
    <div class="employer__alert-box">
      <div class="left_part">
        <div class="employer__alert-title">
          {{ 'OCR_ALERT.TITLE' | translate }}
        </div>
        <div class="employer__alert-info">
          {{ 'OCR_ALERT.ALERT_INFO' | translate }} <strong>{{ 'OCR_ALERT.ALERT_INFO_2' | translate }}</strong>
        </div>
      </div>
      <div class="right_part">
        <img src="../../../assets/svg/1ludz1.svg" class="icon_1">
        <img src="../../../assets/svg/1ludz2.svg" class="icon_2">
        <img src="../../../assets/svg/1ludz3.svg" class="icon_3">
      </div>
    </div>
  </div>
}
<!-- End OCR Alert -->

<div class="accordion__content form-content {{contentClass}}" [class.no-bg]="noBg" [hidden]="isCollapsed" [class.isEmployer]="isEmployer">
  @if (showRemove) {
    <div class="accordion__remove" [class.m_bot]="btnRemoveMargin">
      <div class="level-title" [class.isEmployer]="isEmployer">
        @if (prefixLabel) {
          <span class="preIndex">{{ prefixLabel }}.</span>
        }
        @if (transalteDelLabel) {
          <span>{{ deleteLabel | translate }}</span>
        }
        @if (!transalteDelLabel) {
          <span>{{ deleteLabel }}</span>
        }
        @if (postfixLabel) {
          <span class="postIndex">{{ postfixLabel }}</span>
        }
      </div>
      @if (isRemoveShown) {
        <div class="level-item" (click)="onRemoveClicked($event)">
          <a [ngClass]="isRemoveActive ? 'accordion__remove' : 'accordion__remove inactive'">
            <div class="svg-icon">
              <span class="svg-icon__label">{{ 'COMMON.REMOVE' | translate }}</span>
              <img src="../../../assets/svg/del_accordion.svg" alt="delete" class="svg-icon__img" />
            </div>
          </a>
        </div>
      }
    </div>
  }
  <ng-content></ng-content>
</div>
</div>
